import create from 'zustand';

const BLANK_PROFILE_INITIAL = {
	blank: {
		id: 0,
		title: '',
		gradeId: 0,
	},
	grade: {
		id: 0,
		title: ''
	},
	program: {
		id: 0,
		title: ''
	}
};

export const useBlankProfileStore = create(set => ({
	...BLANK_PROFILE_INITIAL,

	// Initialize blank's state
	onInit: (blank) => set((state) => ({
		blank: {
			id: blank?.id,
			title: blank?.title,
			gradeId: blank?.gradeId
		},
		grade: blank?.grade ? {
			id: blank.grade.id,
			title: blank.grade.title
		} : {
			...state.grade
		},
		program: blank?.grade?.program ? {
			id: blank.grade.program.id,
			title: blank.grade.program.title,
		} : {
			...state.program
		}
	})),

	// Update blank's state
	onUpdate: (updated) => set(state => ({
		blank: {
			...state.blank,
			...updated
		}
	})),

	// Reset store to initial state
	onReset: () => set({
		...BLANK_PROFILE_INITIAL
	})
}));